import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/reno_static/fonts/walsheim-condensed-bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22variable%22:%22--font-walsheim-condensed%22}],%22variableName%22:%22walsheimCondensed%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'walsheimCondensed', 'walsheimCondensed Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
